/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_profile__tabs__information__banner = /** @type {(inputs: {}) => string} */ () => {
	return `Diese Daten sind mit Ihrem Michelin-Konto verknüpft.`
};

const en_profile__tabs__information__banner = /** @type {(inputs: {}) => string} */ () => {
	return `These data are linked to your Michelin account.`
};

const es_profile__tabs__information__banner = /** @type {(inputs: {}) => string} */ () => {
	return `Estos datos están vinculados a tu cuenta Michelin.`
};

const fr_profile__tabs__information__banner = /** @type {(inputs: {}) => string} */ () => {
	return `Ces données sont liées à vote compte Michelin.`
};

const it_profile__tabs__information__banner = /** @type {(inputs: {}) => string} */ () => {
	return `Questi dati sono collegati al tuo conto Michelin.`
};

const nl_profile__tabs__information__banner = /** @type {(inputs: {}) => string} */ () => {
	return `Deze gegevens zijn gekoppeld aan uw Michelin-account.`
};

const pt_profile__tabs__information__banner = /** @type {(inputs: {}) => string} */ () => {
	return `Estes dados estão ligados à sua conta Michelin.`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const profile__tabs__information__banner = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.profile__tabs__information__banner(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("profile__tabs__information__banner", locale)
	if (locale === "de") return de_profile__tabs__information__banner(inputs)
	if (locale === "en") return en_profile__tabs__information__banner(inputs)
	if (locale === "es") return es_profile__tabs__information__banner(inputs)
	if (locale === "fr") return fr_profile__tabs__information__banner(inputs)
	if (locale === "it") return it_profile__tabs__information__banner(inputs)
	if (locale === "nl") return nl_profile__tabs__information__banner(inputs)
	return pt_profile__tabs__information__banner(inputs)
};